import { Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {Observable, Subscription} from 'rxjs';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

/**
 *  Small modal window used in edit modal dialog tables and info icons
 */
@Component({
    selector: 'app-small-text-info-modal',
    templateUrl: './small-text-info-modal.component.html',
    styleUrls: ['./small-text-info-modal.component.scss']
})
export class SmallTextInfoModalComponent extends ModalDialogV3 implements OnInit, OnDestroy {


    public model: {
        title: string, messages: string[], top: number, left: number,
        marginBottom: number, showCloseBtn: true, minHeight: number,
        closeEvent: Observable<any>
    };
    top: string;
    minBottomMargin: number;
    left: string;

    @ViewChild('infoPanel', {static: true}) public infoPanelElem: ElementRef;

    private closeSub: Subscription;

    constructor() {
        super();
    }

    ngOnInit() {
        this.model = <{
            title: string, messages: string[], top: number, left: number,
            marginBottom: number, showCloseBtn: true, minHeight: number,
            closeEvent: Observable<any>
        }>
            this.modalParams.model;

        this.left = this.model.left + 'px';
        this.top = this.model.top + 'px';
        this.minBottomMargin = Number.isFinite(this.model.marginBottom) ? this.model.marginBottom : 10;
        this.fixBottomMargin();


        if ( this.model.closeEvent) {
            this.closeSub = this.model.closeEvent.subscribe(_ => {
                this.close();
            });
        } else {
            console.warn('modal closeEvent is not specified ', this.model);
        }



    }

    onCloseBtnClicked() {
        super.close();
    }

    private fixBottomMargin() {
        setTimeout(_ => {
            // called via timeout after table will be rendered on the screen
            const windowHeight = window.innerHeight;
            const rect = this.infoPanelElem.nativeElement.getBoundingClientRect();
            // console.log('=====rect top', rect.top );

            if (rect.bottom + this.minBottomMargin > windowHeight) {

                const newTop = Math.floor(windowHeight - rect.height - this.minBottomMargin);
                this.top = newTop + 'px';
                // console.log('moved', rect.top - newTop );
            }

        }, 0);
    }


    ngOnDestroy(): void {
       if (this.closeSub) {
           this.closeSub.unsubscribe();
       }
    }
}
